// extracted by mini-css-extract-plugin
export default {"title":"InviteMemberCard_title__uKTnJ","text":"InviteMemberCard_text__Ibiy0"};